/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserPickerItem { 
    id?: number;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    fullName?: string;
    enrollment?: string;
    email?: string;
    photoProfileUrl?: string;
    companyId?: string;
    companyName?: string;
    departmentId?: string;
    departmentName?: string;
    jobPositionId?: string;
    jobPositionName?: string;
}

